
import PersistenceStatus from '@/api/PersistenceStatus';
import { Options, Prop, Vue } from 'vue-property-decorator';
import InitialNetworkError from './InitialNetworkError.vue';
import SavingNotification from './SavingNotification.vue';
import UnrecoverableError from './UnrecoverableError.vue';
@Options({
  components: { InitialNetworkError, SavingNotification, UnrecoverableError },
})
export default class PersistenceNotification extends Vue {
  @Prop({ default: PersistenceStatus.NO_ERROR }) persistenceStatus: PersistenceStatus | undefined;

  private get status(): PersistenceStatus {
    return this.persistenceStatus !== undefined ? this.persistenceStatus : PersistenceStatus.NO_ERROR;
  }

  private getUnrecoverableErrorMessageDetail(): string {
    if (this.persistenceStatus === PersistenceStatus.UNRECOVERABLE_ERROR) {
      return this.$t('err.internet');
    } else {
      return this.$t('err.network');
    }
  }

  private handleExitTest(): void {
    this.$emit('exitTestClicked');
  }

  private get initialNetworkError(): number {
    return PersistenceStatus.INITIAL_ERROR;
  }

  private get savingNotification(): number {
    return PersistenceStatus.SAVING;
  }

  private get unrecoverableError(): number {
    return PersistenceStatus.UNRECOVERABLE_ERROR;
  }

  private get unrecoverableNetworkError(): number {
    return PersistenceStatus.UNRECOVERABLE_NETWORK_ERROR;
  }
}
